import { useEffect, useState } from "react";
import { t } from "i18next";
import performanceIcon from "../../assets/images/performance.svg";
import { useNavigate } from "react-router-dom";
import { LoadingSpinner } from "../general/loading-spinner";
import { AthletePerformanceChart } from "../charts/athlete-performance-chart";
import { getAthletePerformance } from "../../services/athlete";
import { AthletePerformance } from "../../interfaces/athlete";

interface AthletePerformanceBlockProps {
    athlete_id: number;
}

export function AthletePerformanceBlock(props: AthletePerformanceBlockProps) {
    const navigate = useNavigate();

    const [athletePerformance, setAthletePerformance] = useState<AthletePerformance[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getAthletePerformance(props.athlete_id)
            .then(response => {
                setAthletePerformance(response.data);
                setLoaded(true);
            })
    }, []);

    return (
        <div className="block athlete-performance-container">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ performanceIcon } alt={ t("Performance")} />
                    { t("Performance") }
                </h3>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded && athletePerformance.length > 0 &&
                    <AthletePerformanceChart performance={ athletePerformance }  />
                }
            </div>
        </div>
    );
}  
